(function (global) {
    define('LNRS/Components/Forms/MediaContact',[
        "jquery", "vue", "moment", "underscore", "eventManager", "LNRS/Components/Forms/ValidationOptions", "LNRS/Components/Forms/NonEloquaBase", "jqueryValidate", "jqueryUnobtrusiveAjax", "datetimepicker", "Validation/RecaptchaApiLoader"
    ], function ($, Vue, moment, _, eventManager, vo, neBase) {

        var mediaContactFormErrorList = [];

        var component = {
            mounted: function () {
                this.formName = "Media Contact"; // used for analytics
                $.validator.setDefaults(vo.getDefaultOptions());
                $.validator.unobtrusive.options = vo.getUnobtrusiveOptions();

                this.initClientValidationEvents();

                $("#Deadline", this.$el).datetimepicker({
                    format: "MM/DD/YYYY",
                    minDate: moment(new Date().getTime()).toDate(),
                    showTodayButton: true,
                    showClear: true,
                    showClose: true
                });

                this.$recaptchaPlaceholders = $(".g-recaptcha", this.$el);
                eventManager.subscribe('RecaptchaApiLoaded', this.onloadRecaptchaCallback.bind(this));

                this.initErrorList();

                this.$form = $("#" + this.formId, this.$el);
                this.$form.validate();

                this.$result = $("#result-" + this.formId, this.$el);

                this.loaded = true;
            },
            computed: {
                disableBtn: function () {
                    return false;
                }
            },
            methods: {
                onloadRecaptchaCallback: function () {
                    if (this.$recaptchaPlaceholders.length > 0) {
                        neBase.loadRecaptchaCallbackV3(this.$recaptchaPlaceholders, this.recaptchaCallback);
                    }
                },
                recaptchaCallback: function () {
                    this.removeErrorFromErrorList("ReCaptcha");
                    var recaptchaErrorLabel = $("label[for='ReCaptcha']", this.$el);
                    if (recaptchaErrorLabel) {
                        recaptchaErrorLabel.remove();
                    }
                },
                removeErrorFromErrorList: function (id) {
                    var errIndex = mediaContactFormErrorList.indexOf(id);
                    if (errIndex > -1) {
                        mediaContactFormErrorList.splice(errIndex, 1);
                    }
                },
                onBlur: function (e) {
                    this.validateInput(e.currentTarget, false);
                },
                validateInput: function (e, isForSubmition) {
                    var err = neBase.validateInput(e, isForSubmition, mediaContactFormErrorList);
                    if (err) {
                        this.$form.validate().showErrors(err);
                        neBase.trackErrors(this.formName, Object.keys(err).map(function (key) { return err[key]; }));
                    }
                },
                initErrorList: function () {
                    var language = $(this.$form).find("#LanguageName:first").val();
                    if (language !== 'zh-CN') {
                        this.addToErrorList("ReCaptcha");
                    }
                    this.addToErrorList("Name");
                    this.addToErrorList("Organization");
                    this.addToErrorList("BusinessPhone");
                    this.addToErrorList("Email");
                    this.addToErrorList("Deadline");
                    this.addToErrorList("YourMessage");
                },
                addToErrorList: function (id) {
                    var errIndex = mediaContactFormErrorList.indexOf(id);
                    if (errIndex === -1) {
                        mediaContactFormErrorList.push(id);
                    }
                },
                initClientValidationEvents: function () {
                    $("#Name", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#Organization", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#Email", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#BusinessPhone", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#Deadline", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#YourMessage", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                },
                btnClick: function (e) {
                    e.preventDefault();
                    if (!this.loading) {
                        this.submitForm(e);
                    }
                },
                btnBackClick: function (e) {
                    e.preventDefault();
                    this.$result.hide().removeClass("in");
                    this.sent = false;
                    grecaptcha.reset();
                    this.initErrorList();
                },
                submitForm: function () {
                    this.loading = true;
                    var self = this;

                    if (mediaContactFormErrorList.length > 0) {
                        _.each(mediaContactFormErrorList, function (e) {
                            this.validateInput($("#" + e, this.$el).get(0), true);
                        }.bind(this));
                        this.loading = false;
                        return;
                    }

                    // send all fields, with only yes/no for PII data
                    neBase.trackResponses(this.formName, [
                        "Name=" + ($("#Name", this.$el).val() ? "yes" : "no"),
                        "Organization=" + $("#Organization", this.$el).val(),
                        "Email=" + ($("#Email", this.$el).val() ? "yes" : "no"),
                        "BusinessPhone=" + ($("#BusinessPhone", this.$el).val() ? "yes" : "no"),
                        "Deadline=" + $("#Deadline", this.$el).val(),
                        "Your Message=" + ($("#YourMessage", this.$el).val() ? "yes" : "no")
                    ]);

                    if (this.$recaptchaPlaceholders.length > 0) {
                        var clientId = $(self.$el).find('.recaptchaClientId').first().val();
                        var actionName = $(self.$el).find('.recaptchaActionName').first().val();
                        
                        grecaptcha.ready(function () {
                            grecaptcha.execute(clientId, { action: actionName })
                                .then(function (token) {
                                    this.saveData();
                                }.bind(this));
                        }.bind(this));
                    }
                    else {
                        this.saveData();
                    }
                },
                saveData: function () {
                    $.ajax(neBase.submitObj(this.$form))
                    .fail(function (response) {
                        var errors = neBase.submitFail(response);
                        if (!_.isEmpty(errors)) {
                            this.$form.data("validator").showErrors(errors);
                        }
                    }.bind(this))
                    .always(function (response) {
                        var responseResult = neBase.submitSuccess(response, this.$form, this.$result);
                        this.resultTitle = responseResult.resultTitle;
                        this.resultText = responseResult.resultText;
                        this.sent = responseResult.sent;
                        this.loading = false;
                    }.bind(this));
                }
            }
        };

        return function initMediaContactForm(args) {
            component.el = args.scope;
            component.data = {
                loaded: false,
                formId: args.FormId,
                loading: false,
                sent: false,
                resultTitle: null,
                resultText: null,
                $recaptchaPlaceholders: null,
                validator: null,
                $form: null,
                $result: null
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };
    });
})(this);
